{
  "en-US": "English US",
  "es-ES": "Español",
  "fr-FR": "Français",
  "de-DE": "Deutsch",
  "ru-RU": "Русский"
}
